import React from 'react';

import FullWrapper from '../../layouts-components__common-cases/full-wrapper';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';
import CommonTitle from '../../../common-components/common-title';
import CommonCircleList from '../../../common-components/common-circle-list';
import BasicLink from '../../../../../../../core/BasicLink';
import { getExternalLink } from '../../../../../../../core/BasicImage/basic-image.util';

let list = {
    colorNumber: '#7927E0',
    list: [
        'Панелей Вебмастеров и Справочников',
        'Файлов sitemap и robots.txt',
        'Оптимизации и контента',
        'Скорости загрузки сайта',
        'Отображения без JS',
        'Мобильной версии',
    ],
};

const Competitors = () => {
    return (
        <div className="competitors">
            <FullWrapper isMargin={false}>
                <ScrollAnimation animateIn="fadeIn" offset={100} animateOnce={true} duration={1}>
                    <ScrollAnimation
                        animateIn="fadeInUp"
                        offset={100}
                        animateOnce={true}
                        duration={1}
                        className="upgreat-tasks__content"
                    >
                        <div className="competitors__content">
                            <div className="competitors__block-text">
                                <CommonTitle>Аудит и анализ конкурентов</CommonTitle>
                                <div className="competitors__text">
                                    Сначала мы проводим детальный технический SEO-аудит сайта.{' '}
                                    <span>Это анализ:</span>
                                </div>
                                <div className="competitors__list">
                                    <CommonCircleList CommonCircleList={list} />
                                </div>
                                <div className="competitors__text-bold">
                                    А также сканирование сайта (проверка кодов ответа, дубли мета) и
                                    др. Аудит помогает найти грубые ошибки и устранить их до начала
                                    продвижения.
                                </div>
                                <div className="competitors__text-bold">
                                    Анализ прямых конкурентов помогает не только найти неочевидные
                                    ошибки, но и новые точки роста для клиента.
                                </div>
                            </div>

                            <div className="competitors__block-right">
                                <div className="competitors__block-img">
                                    <img
                                        className="competitors__img"
                                        src="/images/pic/seo-fintech/competitors.png"
                                        alt=""
                                        loading="lazy"
                                    />
                                </div>
                                <BasicLink
                                    href={getExternalLink('/files/seo-fintech.pdf')}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="competitors__example-analysis"
                                >
                                    <div className="competitors__example-analysis_text">
                                        <span>Пример анализа</span>
                                        Как выглядит готовый аудит
                                    </div>
                                    <img
                                        alt="Пример анализа"
                                        src="/images/pic/seo-fintech/competitors-icon.svg"
                                        loading="lazy"
                                    />
                                </BasicLink>
                            </div>
                        </div>
                    </ScrollAnimation>
                </ScrollAnimation>
            </FullWrapper>
        </div>
    );
};

export default Competitors;
